import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

import {USER_CUSTOM} from '@/libs/userAbility/userAbilityRoles/rolesUser';

import IProfile from '@/interfaces/IProfile';
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue';

@Component({
    name: 'HeaderDropDown',
    components: {
        AppHeaderDropdown
    }
})
export default class HeaderDropDown extends Vue {
    @Prop(Object) private profile!: IProfile;

    @Action private logout!: () => Promise<void>;

    private get userName() {
        return this.profile ? this.profile.username : ''
    }

    private get userCustom () {
        return USER_CUSTOM;
    }
    
}